import { memo, useCallback, useMemo, useState } from 'react';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import Notes from '../Notes';
import { Container, Row, Col } from 'react-bootstrap';
import { BzButton, BzTab, BzTabs, BzToolTip } from '../../../components';
import { NewNote, MyNotes } from "../../../containers/Watchlist";
import { useDispatch, useSelector } from 'react-redux';
import { updateNotes } from '../../../redux/actions/notes';
import { SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../utils/global_variables';


const SideNotes = ({ setIsExpanded, sideContentId, setActiveMenu, setToggleSideContainer, ...props }) => { //BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23
    const dispatch = useDispatch();

    const arrMyNotes = useSelector(state => state.notes.arrMyNotes);

    const [activeTabSideNotes, setActiveTabSideNotes] = useState('tabNewNotes');

    const onSaveNotes = useCallback((strTitle, strIdea, strTags) => {
        const newDate = new Date();
        const objNewNotes = {
            id: arrMyNotes.length + 1,
            title: strTitle,
            description: strIdea,
            categoryName: strTags,
            issueDate: newDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ',' + newDate.getDate() + ' ' + newDate.toLocaleString('en-US', { month: 'short' }) + ' ' + newDate.getFullYear().toString().slice(-2)

        };
        dispatch(updateNotes(objNewNotes));
    }, [dispatch, arrMyNotes]);

    const notesTabs = useMemo(() =>
        [
            {
                id: '1',
                title: 'Write a new Note',
                tabKey: 'tabNewNotes',
                icon: <div className='icon-16 icon-edit icon-primary me-2 float-start'></div>,
                tabContent: <NewNote onSaveNotes={onSaveNotes} />,
            },
            {
                id: '2',
                title: 'My Notes',
                tabKey: 'tabMyNotes',
                tabContent: <MyNotes arrMyNotes={arrMyNotes} />,
            },
        ], [arrMyNotes, onSaveNotes]);



    return (
        <>
            <ContainerHeader>
                <Container fluid className='p-0'>
                    <Row className='g-0 bdr-btm p-3'>
                        <Col md={9} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text text-uppercase line-height-1'>NOTES</div>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-self-center'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close ms-3' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); setToggleSideContainer(false);
                                    setActiveMenu({});
                                }}>
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>
                    <Row className='g-0 my-2 px-3'>
                        <Col>
                            <div className='horizontal-scroll-wrap'>
                                <BzTabs className='nav nav-tabs'>
                                    {notesTabs?.map((each, i) => (
                                        <BzTab onClick={() => setActiveTabSideNotes(each.tabKey)} key={i} className='nav-link text-capitalize' isActive={each.tabKey === activeTabSideNotes} tabKey={each.tabKey}>
                                            {each?.icon}
                                            {each.title}
                                            {each?.id === '2' ? ` (${arrMyNotes.length})` : null}
                                        </BzTab>
                                    ))}
                                </BzTabs>
                            </div>
                        </Col>
                    </Row>
                    {
                        activeTabSideNotes === 'tabMyNotes' &&
                        <Row className='g-0 mb-2 px-3'>
                            <Col md={9} className='d-flex justify-content-start align-self-center'>
                                <BzButton className='btn btn-outline btn-md d-flex align-items-center' onClick={() => setActiveTabSideNotes('tabNewNotes')}>
                                    <div className='icon-12 icon-add-circle-fill icon-primary me-2'></div>
                                    <span className='font-medium'>Write a new note</span>
                                </BzButton>
                            </Col>
                            <Col md={3} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-search icon-dark ms-3'></div>
                                <div className='icon-16 icon-close icon-dark ms-3'></div>
                            </Col>
                        </Row>
                    }
                </Container>
            </ContainerHeader>

            <ContainerBody>
                <Notes activeTab={activeTabSideNotes} notesTabs={notesTabs} />
            </ContainerBody>
        </>
    );
};

export default memo(SideNotes);